module.exports = __webpack_public_path__ + "static/media/blikopzeewolde.bdb1aead.png";